import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import i18next from 'i18next';

import { composeValidators, phoneNumberValidation, requiredValidation } from 'helpers/validations';

import Input from 'components/inputs/Input';

import { Title, ViewContainer, ViewContent } from 'styles/view';
import { FormButtonContainer, FormContent, FormSubmitButton } from 'styles/form';

import { IContactSettingsViewProps } from './types';
import { Description, FormContainer } from './styles';
import './i18n';

const ContactSettingsView: FunctionComponent<IContactSettingsViewProps> = ({
  initialValues,
  onSubmit,
}) => {
  return (
    <ViewContainer auth>
      <ViewContent auth>
        <Title>{i18next.t<string>('CONTACT_SETTINGS_VIEW:TITLE')}</Title>
        <Description variant="body1">
          {i18next.t<String>('CONTACT_SETTINGS_VIEW:DESCRIPTION')}
        </Description>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={({ handleSubmit, pristine, submitting }) => (
            <FormContent data-testid="contact-settings-form" onSubmit={handleSubmit}>
              <FormContainer>
                <Field
                  label={i18next.t<String>('CONTACT_SETTINGS_VIEW:WHATSAPP_LABEL')}
                  name="whatsappNumber"
                  render={Input}
                  validate={composeValidators(requiredValidation, phoneNumberValidation)}
                  helperText={i18next.t<String>('CONTACT_SETTINGS_VIEW:HELPER_TEXT')}
                />
                <FormButtonContainer>
                  <FormSubmitButton disabled={pristine || submitting} type="submit">
                    {i18next.t<string>('CONTACT_SETTINGS_VIEW:SUBMIT_BUTTON')}
                  </FormSubmitButton>
                </FormButtonContainer>
              </FormContainer>
            </FormContent>
          )}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default ContactSettingsView;
